import { render } from "./StudentClassBrief.vue?vue&type=template&id=9c7aa826&scoped=true"
import script from "./StudentClassBrief.vue?vue&type=script&lang=js"
export * from "./StudentClassBrief.vue?vue&type=script&lang=js"

import "./StudentClassBrief.vue?vue&type=style&index=0&id=9c7aa826&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-9c7aa826"]])

export default __exports__